import { toast } from "react-toastify";
import moment from "moment";
import DOMPurify from "dompurify";

import { formatDate } from "./date";

export function alertMessage(alert) {
  if (alert.show) {
    switch (alert.message.type) {
      case "success":
        toast(alert.message.content, { className: "alert" });
        break;
      case "error":
        if (alert.message.content === "") {
          toast.error(
            "Sorry, something went wrong. Please contact your administrator"
          );
        } else if (alert.message.content !== "Cancel") {
          toast.error(alert.message.content);
        }
        break;
      case "info":
        toast.info(alert.message.content);
        break;
      default:
        return false;
    }
  }
  return false;
}

export function utcToYMD(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = d.getDate();
  const year = d.getFullYear();
  // hour = d.getHours(),
  // minute = d.getMinutes();

  if (month.toString().length < 2) month = `0${month}`;
  if (day.toString().length < 2) day = `0${day}`;

  const formattedDate = [year, month, day].join("-");
  // let time = [hour, minute].join(':');
  return formattedDate;
}

export function getMonthDateRange(year, month) {
  // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
  // array is 'year', 'month', 'day', etc
  const startDate = moment([year, month - 1]);

  // Clone the value before .endOf()
  const endDate = moment(startDate).endOf("month");

  // just for demonstration:
  // console.log(startDate.toDate());
  // console.log(endDate.toDate());

  // make sure to call toDate() for plain JavaScript date type
  return `${formatDate(startDate, "MM/dd/yyyy")} through ${formatDate(
    endDate,
    "MM/dd/yyyy"
  )}`;
}

export function randomString(length, chars) {
  let result = "";
  for (let i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

export function isBefore(time) {
  const today = formatDate(new Date(), "yyyy-MM-dd");
  return moment().isBefore(moment(`${today} ${time}`));
}

export const PhoneNumber = (number) => {
  let formatted_number;
  if (number) {
    const phoneNum = number
      .toString()
      .replace(/[^0-9]+/g, "")
      .replace(/\s+/, "");

    if (phoneNum.length === 8) {
      formatted_number = phoneNum.replace(
        /([0-9]{2})([0-9]{3})([0-9]{3})/,
        "$1 $2 $3"
      );
    } else if (number.length === 10) {
      formatted_number = phoneNum.replace(
        /([0-9]{3})([0-9]{3})([0-9]{4})/,
        "($1) $2-$3"
      );
    } else if (number.length === 11) {
      formatted_number = phoneNum.replace(
        /([0-9]{1})([0-9]{3})([0-9]{3})([0-9]{4})/,
        "$1($2) $3-$4"
      );
    } else if (number.indexOf("+") === 0) {
      formatted_number = phoneNum.replace(
        /([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{3})/,
        "$1 $2 $3 $4"
      );
    }
  }

  return formatted_number;
};

export const uuidGenerator = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );

export const formatDuration = (ms, interval = ["day", "hour", "minute"]) => {
  let newMs = ms;
  if (newMs < 0) {
    newMs = -newMs;
  }
  const time = {
    day: Math.floor(newMs / 86400000),
    hour: Math.floor(newMs / 3600000) % 24,
    minute: Math.floor(newMs / 60000) % 60,
    second: Math.floor(newMs / 1000) % 60,
    millisecond: Math.floor(newMs) % 1000
  };
  return Object.entries(time)
    .filter(([key, val]) => interval.includes(key) && val !== 0)
    .map(([key, val]) => `${val} ${key}${val !== 1 ? "s" : ""}`)
    .join(", ");
};

export const validateAuthRoles = (auth, rolesRequired) =>
  auth &&
  Array.isArray(auth.roles) &&
  auth.roles.length > 0 &&
  !!auth.roles.filter((role) => rolesRequired.includes(role.name)).length > 0;

export const sanitizeText = (text) => {
  if (typeof text === "object") {
    return JSON.parse(DOMPurify.sanitize(JSON.stringify(text)));
  }
  return DOMPurify.sanitize(text) || "";
};

export const formatCurrency = (value) => {
  if (value) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(value);
  }
  return "$0.00";
};

export function groupByIntoArray(array, f) {
  const groups = {};
  array.forEach(function (o) {
    const group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

export function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(
      Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten
    );
  }, []);
}
